import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="forms--flow-configuration-frequency"
export default class extends Controller {
  static targets = [
    "cron",
    "frequencyTimeContainer",
    "frequencyDaysContainer",
    "frequencyDayContainer",
    "frequencyDayNumberContainer",
    "select",
  ];

  connect() {
    this.initializeFrenquencyInputCron();
    this.setupSelects();
  }

  disconnect() {
    this.cronSelect?.destroy();
    this.selects.forEach((select) => {
      select?.destroy();
    });
  }

  initializeFrenquencyInputCron() {
    this.cronSelect = new TomSelect(this.cronTarget, {
      onChange: () => {
        this.setFrequencyTimeVisibility();
        this.setFrequencyDaysVisibility();
        this.setFrequencyDayVisibility();
        this.setFrequencyDayNumberVisibility();
      },
    });

    this.setFrequencyTimeVisibility();
    this.setFrequencyDaysVisibility();
    this.setFrequencyDayVisibility();
    this.setFrequencyDayNumberVisibility();
  }

  setupSelects() {
    this.selects = this.selectTargets.map((select) => {
      new TomSelect(select, {
        maxOptions: null,
        plugins: ["remove_button"],
      });
    });
  }

  setFrequencyTimeVisibility() {
    const crons = ["daily", "weekly", "monthly"];

    if (crons.includes(this.cronTarget.value)) {
      this.frequencyTimeContainerTarget.classList.remove("d-none");
    } else {
      this.frequencyTimeContainerTarget.classList.add("d-none");
    }
  }

  setFrequencyDaysVisibility() {
    const crons = ["quartly", "hourly", "daily"];

    if (crons.includes(this.cronTarget.value)) {
      this.frequencyDaysContainerTarget.classList.remove("d-none");
    } else {
      this.frequencyDaysContainerTarget.classList.add("d-none");
    }
  }

  setFrequencyDayVisibility() {
    if (this.cronTarget.value == "weekly") {
      this.frequencyDayContainerTarget.classList.remove("d-none");
    } else {
      this.frequencyDayContainerTarget.classList.add("d-none");
    }
  }

  setFrequencyDayNumberVisibility() {
    if (this.cronTarget.value == "monthly") {
      this.frequencyDayNumberContainerTarget.classList.remove("d-none");
    } else {
      this.frequencyDayNumberContainerTarget.classList.add("d-none");
    }
  }
}
